import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";

export default function OutletPassContext(props) {
    const outletContext = useOutletContext()
    return (
        <Outlet context={outletContext} />
    );
}